import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Popup, Marker, useMap, useMapEvents} from "react-leaflet";
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import '../styles/leaflet.css';
import axios from 'axios';
import * as L from 'leaflet';
import CenterButton from './CenterButton';

const Search = (props) => {
    const { provider } = props;
    const map = useMap();

    useEffect(() => {
        const searchControl = new GeoSearchControl({
            showmarker:false,
            provider,
        })

        map.addControl(searchControl) // this is how you add a control in vanilla leaflet
        return () => map.removeControl(searchControl)
    }, [props])

    return null // don't want anything to show up from this comp
}

const reverseSearch = async (Lat, Lng) => {
    try{
        const response = await axios.get(
            'https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat='+Lat+'&lon='+Lng
        );
        return response; 
    } catch (error) {
        console.error(error);
        return error.toString();
    }
}

function FindMe(){
    const map=useMap();

    useEffect(()=>{
        map.locate().on("locationfound", function(e){
            map.flyTo(e.latlng,map.getZoom());
            const radius=e.accuracy;
            const circle=L.circle(e.latlng, radius);
            circle.addTo(map);
        });
    }, [map]);

    return null;
}



/*function CenterLocation(){
    useEffect(() => map.locate(),[]);
   
    const map = useMapEvents({ 
        locationfound(e) {
            map.flyTo(e.latlng, map.getZoom());
        },
    });
}*/

function ClickMarker({handleMarkerLocation, handleApproximateAddress})  {
    const[position, setPosition] = useState(null)
    const map = useMapEvents({
        async click(e) {
            setPosition(e.latlng);
            console.log(e.latlng.lat);
            let address = await reverseSearch(e.latlng.lat, e.latlng.lng);
            console.log(address);
            handleMarkerLocation(e);
            handleApproximateAddress(typeof address!=='undefined'?typeof address.data.address!=='undefined'?address.data.address:{road:"No Address Found"}:{road:"No Address Found"});
        }
    });
    
    return position === null ? null :(
        <Marker position={position}>
            <Popup>Approximate Position of Issue</Popup>
        </Marker>
    )
}

function Map({markerLocation, handleMarkerLocation, handleApproximateAddress}) {
    const [position, setPosition]=useState([39.1157, -77.5636]);

    const style = {
        width: "100%",
        height: "300px"
      };

/*    const buttonStyle={
        position: "absolute",
        top: "20px",
        right: "20px",
        padding: "10px",
        zIndex: "400",
      }
*/
    return(
        <MapContainer center={position} zoom={14} scrollWheelZoom={false} style={style}>
            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            <ClickMarker handleMarkerLocation={handleMarkerLocation} handleApproximateAddress={handleApproximateAddress}></ClickMarker>
            <Search provider={new OpenStreetMapProvider({params:{countrycodes:"us",viewbox:[39.065836,-77.671143,39.181399,-77.491241]}})} />
            <CenterButton title={"Find Me"}></CenterButton>

        </MapContainer>
    )
}

export default Map